import { useNavigate } from 'react-router-dom';
import { Grid, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { loginUser } from '../../api/api-middleware';
import AuthWrapper from '../../layout/auth/auth-wrapper';
import StatusAlert from '../elements/Alert';
import LoginForm from './LoginForm';
import useAuthToken from '../../hooks/getUserData';

const LoginUser = ({ setLoading }) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState({ message: '', type: '' });
  const token = useAuthToken();

  useEffect(() => {
    if (token) {
      navigate('/dashboard', { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const addData = (data) => {
    const auth_token = `Bearer ${data.auth_token}`;
    localStorage.setItem('token', auth_token);
    localStorage.setItem('user', JSON.stringify(data?.user));
    localStorage.setItem('role', JSON.stringify(data?.user?.role));
  };

  const handleLogin = async (values) => {
    try {
      const res = await loginUser({ ...values, platform: 'web' });
      const data = await res.json();
      if (data.auth_token) {
        addData(data);
        setTimeout(() => navigate('/dashboard', { replace: true }), 1000);
      } else if (data.message) {
        setStatus({ message: data.message, type: 'error' });
      }
    } catch (error) {
      setStatus({ message: 'An error occurred during login', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthWrapper>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <StatusAlert status={status} />
        </Grid>
        <Grid item xs={12}>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            sx={{ mb: { xs: -0.5, sm: 0.5 } }}>
            <Typography variant="h4">Login</Typography>
            <Typography variant="h4">Admin Portal</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <LoginForm handleLogin={handleLogin} />
        </Grid>
      </Grid>
    </AuthWrapper>
  );
};

export default LoginUser;
